import moment from "moment-timezone";

export const date_time_format = (date: any, format = "ddd, DD MMM hh:mm A") => {
  const formattedDate = moment(date).format(format);
  return formattedDate;
};
